import React from 'react'
import {Trans, useTranslation} from 'react-i18next'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'
import {Domains, PaymentMethodDetails, TApplePayPaymentMethodStore} from '@/pages/payment-methods'
import {PaymentMethodsApplePayStoreSymbol} from '@/pages/payment-methods/PaymentMethods/PaymentMethods'
import {PaymentMethodType} from '@/constants'
import {COMPANY_NAME} from '@/constants/app'

export const ApplePayPaymentMethod = observer(() => {
    const {t} = useTranslation()
    const store = useInjection<TApplePayPaymentMethodStore>(PaymentMethodsApplePayStoreSymbol)

    return (
        <>
            <PaymentMethodDetails
                title={t('ApplePayPaymentMethod.title')}
                description={
                    <Trans
                        i18nKey='ApplePayPaymentMethod.description'
                        components={{br: <br />}}
                        values={{companyName: COMPANY_NAME}}
                    />
                }
                paymentMethodType={PaymentMethodType.applepay}
                stores={store.stores}
            />
            <Domains />
        </>
    )
})
